import React, { Component } from 'react';
import styled from 'styled-components';

import { Preview } from '../components/Preview';
import { PostPreviewListWrapper } from '../components/Preview/styled';
import SEO from '../components/SEO';

class Category extends Component {
  render () {
    const posts = this.props.data.allContentfulCategory.edges[0].node.blogpost;
    const siteMetadata = this.props.data.site.siteMetadata;

    return (
      <div>
        <SEO 
          title={siteMetadata.title}
          description={siteMetadata.description}
          url={siteMetadata.url}
          image={siteMetadata.image}
          twitter={siteMetadata.twitter}
        />
        <PostPreviewListWrapper>
          {posts.map((post, id) => {
            return (
              <Preview 
                key={post.id}
                slug={post.slug}
                category={post.category[0].slug}
                title={post.title}
                avatar={post.author[0].avatar.file.url}
                name={post.author[0].name}
                createdAt={post.createdAt}
                excerpt={post.childContentfulBlogPostBodyTextNode.childMarkdownRemark.html}
              />
            )
          })}
        </PostPreviewListWrapper>
      </div>
    );
  }
}

export default Category;

export const categoryQuery = graphql`
  query CategoryByName($category: String!){
    site {
      siteMetadata {
        title
        description
        image
        url
        twitter
      }
    }
    allContentfulCategory(
      filter: { slug: { eq: $category } }
    ) {
      edges {
        node {
          id
          blogpost {
            slug
            title
            createdAt(formatString: "MMMM DD, YYYY")id
            category {
              slug
            }
            author {
              name
              avatar {
                file {
                  url
                }
              }
            }
            childContentfulBlogPostBodyTextNode {
              childMarkdownRemark {
                html
              }
            }
          }
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/templates/category-page.js